import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Auth, sendEmailVerification } from '@angular/fire/auth';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.css']
})
export class VerifyEmailComponent implements OnInit, OnDestroy {
  email: string | null = null;
  cooldown = 0;
  cooldownSub?: Subscription;
  loading = false;

  constructor(
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private router: Router,
    private auth: Auth
  ) {}

  ngOnInit() {
    const user = this.auth.currentUser;
    this.email = user?.email || null;
    // Start cooldown since email was sent during registration
    this.startCooldown();
  }

  resendVerification() {
    if (this.cooldown > 0) return;
    const user = this.auth.currentUser;
    if (user) {
      this.loading = true;
      sendEmailVerification(user)
        .then(() => {
          this.snackBar.open('Verification email resent!', 'Close', { duration: 7000 });
          this.startCooldown();
        })
        .catch(() => {
          this.snackBar.open('Failed to resend email.', 'Close', { duration: 7000 });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  startCooldown() {
    this.cooldown = 60;
    this.cooldownSub = interval(1000).subscribe(() => {
      this.cooldown--;
      if (this.cooldown <= 0 && this.cooldownSub) {
        this.cooldownSub.unsubscribe();
      }
    });
  }

  async checkVerified() {
    const user = this.auth.currentUser;
    if (!user) return;
    try {
      await user.reload();
      if (user.emailVerified) {
        this.snackBar.open('Email verified!', 'Close', { duration: 7000 });
        this.router.navigate(['/models']);
      } else {
        this.snackBar.open('Email not verified yet.', 'Close', { duration: 7000 });
      }
    } catch (e) {
      this.snackBar.open('Could not refresh user state.', 'Close', { duration: 7000 });
    }
  }

  logout() {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    if (this.cooldownSub) this.cooldownSub.unsubscribe();
  }
}
